import React from 'react';
import InputMask from 'react-input-mask';
import { normalizeTimeValue } from 'src/utils/CommonFunctions';

interface IInputMaskCmpProps {
    parentClassName?: string;
    inputMainClassName?: string;
    labelIconRight?: React.ReactNode | null;
    labelWrapClass?: string;
    label?: string;
    labelClassName?: string;
    required?: boolean;
    requiredClassName?: string;
    mask: string;
    inputName?: string;
    className?: string;
    placeholder?: string;
    onChange?: any;
    onFocus?: any;
    onBlur?: any;
    tabIndex?: number;
    min?: number;
    maxLength?: number;
    minLength?: number;
    max?: number;
    autoFocus?: boolean;
    value?: any;
    disabled?: boolean;
    readOnly?: boolean;
    onKeyDown?: any;
    errorText?: string;
    isError?: boolean;
    isShowAiStar?: boolean;
    isShowDisableClass?: boolean;
    HandleChange?: any;
    handleFocus?: any;
    handleBlur?: any;
    handleInputKeyDown?: any;
    icon?: React.ReactNode;
}

const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, customHandler?: any) => {
    customHandler?.(e);
    if (!/^\d$/.test(e?.key)) return;

    const input = e?.currentTarget;
    const digits = (input?.value || '')?.replace(/[^0-9]/g, '');
    const pos = input?.selectionStart || 0;
    let idx = 0;
    for (let i = 0; i < pos && i < input?.value?.length; i++) if (/\d/.test(input?.value[i])) idx++;

    const key = +e?.key;

    // Hour tens 3-9: auto-advance to minutes; blur normalizes to 03-09
    if (idx === 0 && key > 2) {
        requestAnimationFrame(() =>
            requestAnimationFrame(() => {
                if (input) input.setSelectionRange(3, 3);
            })
        );
    }

    // Minute tens 6-9: auto-advance past end; blur normalizes to 06-09
    if (idx === 2 && key > 5) {
        requestAnimationFrame(() =>
            requestAnimationFrame(() => {
                if (input) input.setSelectionRange(5, 5);
            })
        );
    }

    // prettier-ignore
    const invalid = (idx === 1 && +(digits[0] + e.key) > 23) || (idx === 3 && +(digits[2] + e.key) > 59);

    if (invalid) e?.preventDefault();
};

function InputMaskCmp({
    parentClassName = '',
    inputMainClassName = '',
    labelIconRight = null,
    labelWrapClass = '',
    label = '',
    labelClassName = '',
    required = false,
    requiredClassName = '',
    mask = '',
    inputName = '',
    className = '',
    placeholder = '',
    HandleChange,
    handleFocus,
    handleBlur,
    tabIndex,
    min,
    maxLength,
    minLength,
    max,
    autoFocus,
    value,
    disabled,
    readOnly,
    handleInputKeyDown,
    errorText,
    isError,
    isShowAiStar,
    isShowDisableClass,
    icon,
}: IInputMaskCmpProps) {
    const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (mask === '99:99' && HandleChange) {
            const normalized = normalizeTimeValue(e.target.value);
            const current = (e.target.value || '').replace(/[^0-9]/g, '');

            if (current && normalized !== e.target.value) {
                HandleChange({ target: { value: normalized } });
            }
        }

        handleBlur?.(e);
    };

    return (
        <div className={`${parentClassName}`}>
            <div className={`${inputMainClassName}`}>
                <div className={`${labelIconRight ? 'flex justify-between' : ''} ${labelWrapClass}`}>
                    {label && (
                        <label className={`form_label ${labelClassName}`}>
                            {label}
                            {required && <span className={`text-red-600 ml-0.5 leading-4 text-xs ${requiredClassName}`}>*</span>}
                        </label>
                    )}
                    {labelIconRight && labelIconRight}
                </div>
                <div className={`relative flex justify-center items-center `}>
                    <InputMask
                        mask={mask}
                        name={inputName}
                        className={`form_control ${className} ${errorText && 'is-invalid'} ${isError ? 'border-red-600 hover:border-red-600' : ''} ${isShowAiStar ? 'pl-7' : ''} ${
                            isShowDisableClass ? 'disabled:border-borderPrimary disabled:bg-gray50 disabled:text-gray500 [&:disabled>svg]:hidden disabled-input disabled:opacity-100' : ''
                        }`}
                        placeholder={placeholder}
                        onChange={HandleChange}
                        onFocus={handleFocus}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                        min={min}
                        maxLength={maxLength}
                        minLength={minLength}
                        max={max}
                        autoFocus={autoFocus}
                        value={value}
                        disabled={disabled}
                        required={required}
                        readOnly={readOnly}
                        onKeyDown={mask === '99:99' ? (e: any) => handleOnKeyDown(e, handleInputKeyDown) : handleInputKeyDown}
                    />
                    {icon && icon}
                </div>
            </div>
        </div>
    );
}

export default InputMaskCmp;
